import './Login.js'
import './App.css';
import MasterPage from './MasterPage.js';
import Login from './Login.js';
import { useContext, useEffect, useState } from 'react';
import AuthContext from './Context/AuthProvider.js';
import { ThemeProvider } from '@emotion/react';
import theme from './Theme.js';
import { getAuth } from './Utility/AuthManager.js';
import { SnackbarProvider } from './Utility/UserMessageContext.js';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ResetPassword from './ResetPassword.js';

function App() {
  const { auth } = useContext(AuthContext);
  const { setAuth } = useContext(AuthContext);
  const [readingAuth, setReadingAuth] = useState(true);

  useEffect(() => {
    if (!auth) {
      setAuth(getAuth());
    }
    setReadingAuth(false);
  }, [auth, setAuth]);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
            {readingAuth ? (
              <div>Loading</div>
            ) : (
              <Routes>
                <Route path="/resetpassword" element={<ResetPassword />} />
                <Route
                  path="*"
                  element={
                    auth?.selectedFacility ? (
                      <MasterPage />
                    ) : (
                      <Login />
                    )
                  }
                />
              </Routes>
            )}
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
